import { useEffect } from "react";

export default function useKeyboardNavigation(openEPG, goBack, closeEPG, isOpen) {
  useEffect(() => {
    const OPEN = new Set(["Enter", "ArrowUp"]);
    const CLOSE = new Set(["Back", "Backspace", "BrowserBack", "Escape", "GoBack"]);

    let rafId = null;
    let pending = null;

    const flush = () => {
      rafId = null;
      const a = pending;
      pending = null;
      // Back button now does not always close EPG
      if (a === "close") goBack();
      else if (a === "open") openEPG();
    };

    const handle = (e) => {
      if (CLOSE.has(e.key)) {
        if (e.key === "Backspace") e.preventDefault?.();
        pending = "close";
      } else if (OPEN.has(e.key)) {
        if (pending !== "close") pending = "open";
      } else return;

      if (rafId == null) rafId = requestAnimationFrame(flush);
    };

    const handleConnectionChange = (e) => {
      // If internet goes down and EPG is open, close the EPG
      if (!e.detail.connected && isOpen) closeEPG();
    };

    window.addEventListener("keydown", handle, { capture: true, passive: false });
    window.addEventListener('connectionchange', handleConnectionChange);

    return () => {
      window.removeEventListener("keydown", handle, { capture: true });
      window.removeEventListener('connectionchange', handleConnectionChange);
      if (rafId != null) cancelAnimationFrame(rafId);
    };
  }, [openEPG, goBack, closeEPG, isOpen]);
}
